import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "../lib/SupabaseClient";

interface LocationState {
    candidateId: string;
    testId: number;
}

export default function CandidateProfile() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const { candidateId, testId } = (state || {}) as LocationState;

    const [candidate, setCandidate] = useState<any>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!candidateId) {
            navigate("/candidate/login");
            return;
        }

        async function fetchCandidate() {
            const { data, error } = await supabase
                .from("candidates")
                .select("full_name, email, phone, mugshot_url")
                .eq("id", candidateId)
                .single();

            if (error) console.error("Profile load error:", error);
            setCandidate(data);
            setLoading(false);
        }

        fetchCandidate();
    }, [candidateId, navigate]);

    if (loading) return <p className="text-center p-6">Loading profile...</p>;
    if (!candidate) return <p className="text-center p-6">Candidate not found.</p>;

    return (
        <div className="max-w-md mx-auto p-6 text-center">
            <h1 className="text-2xl font-bold mb-4">Confirm Your Profile</h1>
            <p className="text-gray-600 mb-6">
                Please confirm your information before starting your test.
            </p>

            <div className="border rounded-lg shadow-md p-4 mb-4">
                {candidate.mugshot_url ? (
                    <img
                        src={candidate.mugshot_url}
                        alt="Candidate mugshot"
                        className="w-40 h-40 mx-auto rounded-full object-cover mb-4 border"
                    />
                ) : (
                    <div className="w-40 h-40 mx-auto rounded-full bg-gray-200 mb-4 flex items-center justify-center text-gray-400">
                        No photo
                    </div>
                )}

                <h2 className="text-xl font-semibold">{candidate.full_name}</h2>
                <p className="text-gray-700">{candidate.email}</p>
                <p className="text-gray-500">{candidate.phone}</p>
            </div>

            <button
                onClick={() => navigate(`/candidate/test/${testId}`)}
                className="w-full bg-indigo-600 text-white py-3 rounded font-semibold shadow hover:bg-indigo-700 transition"
            >
                ✅ Start Exam
            </button>

            <button
                onClick={() => navigate("/candidate/enroll", { state: { candidateId } })}
                className="w-full mt-3 bg-gray-300 text-gray-800 py-2 rounded hover:bg-gray-400 transition"
            >
                🔁 Retake Photo
            </button>
        </div>
    );
}
